import React, { useEffect, useRef } from "react";
import { useProgressiveFit } from "./useProgressiveFit";

export default function EtiketBlok({ selectColor, sizeData, data, getProductTextById }) {
  const { ref, gap, fabricScale, descriptionScale, recompute } = useProgressiveFit({ 
    maxHeight: 108, 
    minGap: 5/12, // 12pt'den 5pt'ye kadar (0.417)
    minFabricScale: 0.3,
    minDescriptionScale: 0.3,
    precision: 0.001 
  });
  const RLI = "\u2067"; // Right-to-Left Isolate
const PDI = "\u2069"; // Pop Directional Isolate
  // Önceki değerleri sakla - gereksiz recompute'ları önlemek için
  const prevDataRef = useRef({ sizeData: null, selectColor: null, fabricData: null });

  function fixMixedDirectionLabel(text) {
    if (!text) return text;
  
    // Segmentlere böl (senin formatın: " / " ile ayrılıyor)
    const parts = text.split(" / ").map(s => s.trim());
  
    // Arapça içeren segmenti izole et (Arapça Unicode blokları)
    const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
  
    const fixed = parts.map(p => {
      if (arabicRegex.test(p)) {
        return `${RLI}${p}${PDI}`;
      }
      return p;
    });
  
    return fixed.join(" / ");
  }
  // İlk yüklemede ve veri değiştiğinde hook'u tetikle
  useEffect(() => {
    // Veri gerçekten değişti mi kontrol et
    const currentSizeDataId = sizeData?.description;
    const currentFabricData = data?.zaraHomeLabel12?.[selectColor]?.fabric;
    const prevData = prevDataRef.current;
    
    const sizeDataChanged = currentSizeDataId !== prevData.sizeData;
    const selectColorChanged = selectColor !== prevData.selectColor;
    const fabricDataChanged = JSON.stringify(currentFabricData) !== JSON.stringify(prevData.fabricData);
    
    // Eğer hiçbir şey değişmediyse recompute yapma
    if (!sizeDataChanged && !selectColorChanged && !fabricDataChanged && prevData.sizeData !== null) {
      return;
    }
    
    // Değerleri güncelle
    prevDataRef.current = {
      sizeData: currentSizeDataId,
      selectColor,
      fabricData: currentFabricData
    };
    
    // Kısa bir gecikme ile tetikle ki DOM render olsun
    const timer = setTimeout(() => {
      if (ref.current) {
        recompute();
      }
    }, 100); // Gecikmeyi biraz artırdık - daha stabil
    
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizeData, data, selectColor, recompute]);

  return (
    <div style={{ position: "relative", width: "52mm", height: "90mm", marginTop: -1 }}>
      <div
        ref={ref}
        style={{
          position: "absolute",
          top: 38.3,
          left: -322.7,
          maxHeight: 108,
          width: "413px", // Sabit genişlik
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          textAlign: "left",
          overflow: "hidden",
          fontFamily: "pdf-force",
  
        }}
        data-fit-gap={gap}
        data-fit-fabric-scale={fabricScale}
        data-fit-description-scale={descriptionScale}
      >
        {/* METİN BLOKLARI - FARKLI BAŞLANGIÇ FONT BOYUTLARI */}
        <div
          className="text-justify pdf-force"
          style={{
            lineHeight: "normal", // OTOMATİK (SABİT)
          }}
        >
          {/* AÇIKLAMA - 6.2PT İLE BAŞLAR */}
          <div
  className="pdf-force"
  style={{
    width: 413,
    fontSize: "6.2pt",
    fontWeight: 400,
    whiteSpace: "normal",
    wordBreak: "normal",
    overflowWrap: "normal",
    unicodeBidi: "plaintext",
    letterSpacing: "-0.034em",
  }}
>
  {fixMixedDirectionLabel(getProductTextById(sizeData.description))}
</div>


          {/* KUMAŞ / KARIŞIM - 8PT İLE BAŞLAR */}
          <div style={{ marginLeft: 0, marginTop: "calc(12pt * var(--fit-gap))", width: 411, maxWidth: 411, overflowWrap: "normal" }}>
            {(() => {
              const fabricData = data.zaraHomeLabel12[selectColor]?.fabric;
              console.log("🔍 [EtiketBlok] Fabric Data:", {
                selectColor,
                fabricData,
                fabricCount: fabricData?.length || 0,
                allFabric: fabricData
              });
              
              return fabricData?.map((fabric, i) => {
                console.log(`🔍 [EtiketBlok] Fabric[${i}]:`, {
                  fabric,
                  mix: fabric.mix,
                  mixCount: fabric.mix?.length || 0
                });
                
                return fabric.mix?.map((mix, j) => {
                  console.log(`🔍 [EtiketBlok] Mix[${i}-${j}]:`, {
                    mix,
                    hasText: !!mix.text,
                    percent: mix.percent,
                    text: mix.text
                  });
                  
                  return mix.text ? (
                    <p
                      key={`${i}-${j}`}
                      className="pdf-force"
                      style={{
                        width: 413,
                        maxWidth: 413,
                        fontSize: "calc(8pt * var(--fit-fabric-scale))", // BAŞLANGIÇ 8PT, SCALE İLE AZALIR
                        marginLeft: -0.5,
                        letterSpacing: "-0.034em", // -34 TRACKING (SABİT)
                        fontWeight: 400,
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflowWrap: "break-word",
                        unicodeBidi: "plaintext",
                        lineHeight: "normal", // OTOMATİK (SABİT)
                        // satırlar arası ekstra boşluğu da gap ile kırpabilirsin:
                        marginTop: "calc(4px * var(--fit-gap))",
                        marginBottom: "calc(2px * var(--fit-gap))",
                      }}
                    >
                      {mix.percent && <span>{String(mix.percent).toUpperCase()}%</span>}{" "}
                      {mix.text}
                    </p>
                  ) : null;
                });
              });
            })()}
          </div>
        </div>

        {/* ÜLKE ÇEVİRİLERİ - SABİT FONT BOYUTU */}
        <div
          className="pdf-force"
          style={{
            marginTop: "calc(12pt * var(--fit-gap))",
            fontSize: "4.87pt", // SABİT FONT BOYUTU
            lineHeight: "8px",
            fontWeight: 400,
            letterSpacing: "-0.6px",
            whiteSpace: "normal",
            wordBreak: "normal",
            overflowWrap: "normal",
            unicodeBidi: "plaintext",
            width: 413,
            maxWidth: 413,
            textAlign: "justify", // İKİ YANA YASLA
          }}
        >
          {data.country.translate.map((item) => item.translation).join(" / ")}
        </div>
      </div>
    </div>
  );
}
